import { render, staticRenderFns } from "./simplifyOwnerAccessContol.vue?vue&type=template&id=398c0dc2&scoped=true"
import script from "./simplifyOwnerAccessContol.vue?vue&type=script&lang=js"
export * from "./simplifyOwnerAccessContol.vue?vue&type=script&lang=js"
import style0 from "./simplifyOwnerAccessContol.vue?vue&type=style&index=0&id=398c0dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398c0dc2",
  null
  
)

export default component.exports